var _g, _g2, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9aff75"
    },
    points: "460.255,122.554 490.757,256 460.255,389.447 256,389.447 256,454.809 8.17,256 256,57.192 256,122.554 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.255,
    y: 122.554,
    style: {
      fill: "#366407"
    },
    width: 43.574,
    height: 266.894
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180.289,
    cy: 332.256,
    r: 8.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.894,
    cy: 299.575,
    r: 8.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.83,114.383H264.17V57.192c0-3.143-1.802-6.007-4.636-7.366c-2.833-1.361-6.196-0.974-8.646,0.993L3.058,249.628 C1.124,251.178,0,253.522,0,256c0,2.478,1.124,4.823,3.058,6.373l247.83,198.809c1.478,1.186,3.288,1.797,5.113,1.797 c1.202,0,2.409-0.265,3.533-0.804c2.835-1.359,4.636-4.223,4.636-7.366v-57.191h99.404c4.513,0,8.17-3.658,8.17-8.17 c0-4.512-3.657-8.17-8.17-8.17H256c-4.512,0-8.17,3.658-8.17,8.17v48.334L21.227,256L247.83,74.221v48.333 c0,4.512,3.658,8.17,8.17,8.17h239.66v250.553h-99.404c-4.513,0-8.17,3.658-8.17,8.17c0,4.512,3.657,8.17,8.17,8.17H503.83 c4.513,0,8.17-3.658,8.17-8.17V122.554C512,118.041,508.343,114.383,503.83,114.383z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6b4c5e6b3063f0cd1a82a662a46975ef.svg";
export { ForwardRef as ReactComponent };